import { API_PATHS, interpolatePathParams, ROUTE_PARAMS } from '@futrli/shared-services';
import { LOADER_AREAS } from '@futrli/ui-components';
import { trackPromise } from 'react-promise-tracker';
import { PredictSettings, QueryParams } from '../types';
import { makeRequest, makeRequestWithResponse } from './shared';

/**
 * Retrieves a forecasts settings
 *
 * @param {string} workspaceId - workspace to get settings from
 * @param {string} organisationId - organisation to get settings from
 * @param {string} forecastId - forecast to get settings from
 * @param {QueryParams} queryParams
 * @throws error
 * @returns Promise<void>
 */
export const fetchSettings = async (
  workspaceId: string,
  organisationId: string,
  forecastId: string,
  queryParams: QueryParams = {}
): Promise<PredictSettings> => {
  const path = interpolatePathParams(API_PATHS.SETTINGS, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.FORECAST_ID]: forecastId,
  });

  return makeRequestWithResponse<PredictSettings>({ params: queryParams, url: path, method: 'GET' });
};

/**
 * Updates a forecasts settings
 *
 * @param {unknown} data
 * @param {string} workspaceId - workspace to update settings for
 * @param {string} organisationId - organisation to update settings for
 * @param {string} forecastId - forecast to update settings for
 * @param {QueryParams} queryParams
 * @throws error
 * @returns Promise<void>
 */
export const updateSettings = async (
  data: PredictSettings,
  workspaceId: string,
  organisationId: string,
  forecastId: string,
  queryParams: QueryParams = {}
): Promise<void> => {
  const path = interpolatePathParams(API_PATHS.SETTINGS, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.FORECAST_ID]: forecastId,
  });

  await trackPromise(
    makeRequest({ data, params: queryParams, url: path, method: 'PUT' }),
    LOADER_AREAS.predictArea
  );
};
